import SectionShell from "./SectionShell";
import FieldGroup from "./FieldGroup";
import CountrySelect from "./CountrySelect";
import { inputClass } from "./styles";

const RegionSection = ({
  countries,
  selectedCountryCode,
  regionLocale,
  regionTimezone,
  isSaving,
  onCountryChange,
  onSave,
}) => {
  return (
    <SectionShell
      number="1"
      title="Configure Region"
      subtitle="Select the default country/locale for this restaurant."
    >
      <div className="flex flex-col md:flex-row md:items-end md:gap-4">
        <div className="w-full md:w-1/2">
          <FieldGroup label="Country">
            <CountrySelect
              className={inputClass}
              countries={countries}
              value={selectedCountryCode}
              onChange={(code) => {
                onCountryChange(code);
                // Parent should sync locale/timezone, or we do it here via callback
              }}
            />
          </FieldGroup>
        </div>
        <div className="mt-4 md:mt-0">
          <button
            type="button"
            onClick={onSave}
            disabled={isSaving}
            className={`w-full md:w-auto bg-blue-600 hover:bg-blue-700 text-white px-6 py-2.5 rounded-xl text-sm font-semibold active:scale-[0.98] transition-all duration-200 ${isSaving ? "opacity-70 cursor-not-allowed" : ""}`}
          >
            {isSaving ? "Saving..." : "Save Region"}
          </button>
        </div>
      </div>
      <div className="text-xs text-gray-500 mt-2 flex items-center gap-4">
        <div>
          Locale: <span className="font-semibold">{regionLocale}</span>
        </div>
        <div>
          Timezone: <span className="font-semibold">{regionTimezone}</span>
        </div>
      </div>
    </SectionShell>
  );
};

export default RegionSection;
